import React from 'react'
import CardGrid from 'src/components/card-grid'
import TrainerCard from 'src/components/trainer-card'
import Link from 'src/components/link'
import Page from 'src/components/page'
import Section from 'src/components/section'
import BoxButton from 'src/components/box-button'
import Container from 'src/components/container'
import HeroSection from 'src/components/hero-section'
import { useStore } from 'src/state'

const IndexPage = () => {
  const {
    trainers,
    setFormOverlayId,
    showFormOverlay,
    homePage: { hero, comingSoon, joinUs, team },
  } = useStore()

  return (
    <Page className="page-home">
      <HeroSection {...hero} />
      <Section
        className="coming-soon"
        backgroundImage={comingSoon.backgroundImage}
        backgroundVideoUrl={comingSoon.backgroundVideoUrl}
      >
        <Container>
          <h1 className="centered">{comingSoon.title}</h1>
          <h3 className="section-title centered">{comingSoon.subtitle}</h3>
          {comingSoon.formId ? (
            <BoxButton
              className="form-trigger-btn"
              onClick={() => {
                setFormOverlayId(comingSoon.formId)
                showFormOverlay()
              }}
            >
              {comingSoon.buttonText}
            </BoxButton>
          ) : (
            comingSoon.buttonUrl && (
              <Link newTab={comingSoon.openInNewTab} to={comingSoon.buttonUrl}>
                <BoxButton>{comingSoon.buttonText}</BoxButton>
              </Link>
            )
          )}
        </Container>
      </Section>
      <Section
        className="the-team"
        backgroundImage={team.backgroundImage}
        backgroundVideoUrl={team.backgroundVideoUrl}
      >
        <Container>
          <h2 className="section-title">{team.title}</h2>
          <CardGrid maxCards={6} shouldShuffle={true}>
            {trainers.map((trainer) => (
              <TrainerCard key={trainer.id} {...trainer} />
            ))}
          </CardGrid>
        </Container>
      </Section>
      <Section className="join-us" backgroundImage={joinUs.backgroundImage}>
        <Link to={joinUs.url}>
          <Container>
            <h1>{joinUs.title}</h1>
          </Container>
        </Link>
      </Section>
    </Page>
  )
}

export default IndexPage
